window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.ourDegreeProgramsBox = window.locales.am.ourDegreeProgramsBox || {};window.locales.am.ourDegreeProgramsBox = {...window.locales.am.ourDegreeProgramsBox, ...{
    "heading": "የእኛ ዲግሪ ፕሮግራሞች",
    "content": "ባህላዊ የከፍተኛ ትምህርትን ስለሚያስተጓጉሉ የ {institutionName} አዳዲስ የዲግሪ መርሃ ግብሮች የበለጠ ይረዱ።",
    "button_the_mba": "MBA",
    "button_the_executive_mba": "አስፈፃሚ MBA",
    "button_msba": "MS የንግድ ትንታኔ እና ተግባራዊ AI",
    "button_msse": "MS ሶፍትዌር ምህንድስና",
    "button_msaie": "MS AI ምህንድስና"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.ourDegreeProgramsBox = window.locales.ar.ourDegreeProgramsBox || {};window.locales.ar.ourDegreeProgramsBox = {...window.locales.ar.ourDegreeProgramsBox, ...{
    "heading": "برامجنا الدراسية",
    "content": "تعرف على المزيد حول برامج الدرجات العلمية المبتكرة التي تقدمها {institutionName} والتي تعمل على إحداث ثورة في التعليم العالي التقليدي.",
    "button_the_mba": "ماجستير إدارة الأعمال",
    "button_the_executive_mba": "ماجستير إدارة الأعمال التنفيذي",
    "button_msba": "تحليلات الأعمال والذكاء الاصطناعي التطبيقي MS",
    "button_msse": "ماجستير هندسة البرمجيات",
    "button_msaie": "ماجستير هندسة الذكاء الاصطناعي"
}
};window.locales.en = window.locales.en || {};window.locales.en.ourDegreeProgramsBox = window.locales.en.ourDegreeProgramsBox || {};window.locales.en.ourDegreeProgramsBox = {...window.locales.en.ourDegreeProgramsBox, ...{
    "heading": "Our Degree Programs",
    "content": "Learn more about {institutionName}'s innovative degree programs disrupting traditional higher education.",
    "button_the_mba": "The MBA",
    "button_the_executive_mba": "The Executive MBA",
    "button_msba": "MS Business Analytics and Applied AI",
    "button_msse": "MS Software Engineering",
    "button_msaie": "MS AI Engineering"
}
};window.locales.es = window.locales.es || {};window.locales.es.ourDegreeProgramsBox = window.locales.es.ourDegreeProgramsBox || {};window.locales.es.ourDegreeProgramsBox = {...window.locales.es.ourDegreeProgramsBox, ...{
    "heading": "Nuestros programas de grado",
    "content": "Obtenga más información sobre los innovadores programas de grado de {institutionName} que revolucionan la educación superior tradicional.",
    "button_the_mba": "El MBA",
    "button_the_executive_mba": "El MBA ejecutivo",
    "button_msba": "Análisis de negocios e IA aplicada de MS",
    "button_msse": "Ingeniería de software de maestría",
    "button_msaie": "Maestría en Ingeniería de IA"
}
};window.locales.it = window.locales.it || {};window.locales.it.ourDegreeProgramsBox = window.locales.it.ourDegreeProgramsBox || {};window.locales.it.ourDegreeProgramsBox = {...window.locales.it.ourDegreeProgramsBox, ...{
    "heading": "I nostri corsi di laurea",
    "content": "Scopri di più sugli innovativi programmi di laurea di {institutionName} che stanno rivoluzionando l'istruzione superiore tradizionale.",
    "button_the_mba": "L'MBA",
    "button_the_executive_mba": "L'Executive MBA",
    "button_msba": "Analisi aziendale e IA applicata MS",
    "button_msse": "Ingegneria del software MS",
    "button_msaie": "Ingegneria dell'IA MS"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.ourDegreeProgramsBox = window.locales.zh.ourDegreeProgramsBox || {};window.locales.zh.ourDegreeProgramsBox = {...window.locales.zh.ourDegreeProgramsBox, ...{
    "heading": "我们的学位课程",
    "content": "详细了解{institutionName}颠覆传统高等教育的创新学位课程。",
    "button_the_mba": "工商管理硕士",
    "button_the_executive_mba": "高级工商管理硕士",
    "button_msba": "商业分析与应用人工智能硕士",
    "button_msse": "软件工程硕士",
    "button_msaie": "人工智能工程硕士"
}
};